import React from "react";
import { ArrowRight, ChevronDown } from "lucide-react";

interface HeroProps {
  onOpenRegister?: () => void;
}

export default function Hero({ onOpenRegister }: HeroProps) {
  const scrollToStats = () => {
    const statsSection = document.getElementById("stats");
    if (statsSection) {
      statsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToSteps = () => {
    const stepsSection = document.getElementById("cta-section");
    if (stepsSection) {
      stepsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* ---- Fond vidéo / Overlays ---- */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover pointer-events-none"
        >
          <source src="/videos/video_background.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/60 pointer-events-none" />
      </div>

      {/* Dégradé noir en bas */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent pointer-events-none z-10" />

      {/* ---- CONTENU HERO ---- */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 mt-20">
        <div className="text-center">
          <div className="mb-6" >
          <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
            BOOSTE TES RÉSULTATS
            <span
              className="
                relative 
                block 
                text-transparent 
                bg-clip-text 
                bg-gradient-to-r 
                from-purple-400 
                to-purple-600 
                mt-1 
                z-20 
                leading-[1.2]
                whitespace-nowrap
              "
            >
              DÈS AUJOURD'HUI
            </span>
          </h1>
          </div>
          <p className="text-2xl text-gray-300 mb-12 max-w-3xl mx-auto">
            Rejoins-nous gratuitement et profite d'alertes quotidiennes, d'une formation complète et d'un accompagnement personnalisé.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            {/* Bouton 1 */}
            <button 
              onClick={onOpenRegister}
              className="group px-8 py-4 bg-gradient-to-r from-purple-600 to-purple-800 text-white rounded-md hover:from-purple-700 hover:to-purple-900 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-purple-500/25 flex items-center justify-center gap-2"
            >
              Rejoindre le discord
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button 
              onClick={scrollToSteps}
              className="px-8 py-4 border border-purple-600 text-white rounded-md hover:bg-purple-600/10 transition-all duration-300 shadow-lg hover:shadow-purple-500/25"
            >
              En savoir plus
            </button>
          </div>
        </div>

        {/* ---- BOUTON "DÉCOUVRIR" ---- */}
        <div
          className="
            absolute bottom-4 left-1/2 transform -translate-x-1/2
            z-[9999] pointer-events-auto
          "
        >
          <button
            onClick={scrollToStats}
            className="
              group
              flex flex-col items-center
              gap-1
              cursor-pointer
              bg-transparent
              px-4 py-2
              pointer-events-auto
            "
          >
            <span className="text-sm font-medium tracking-wider uppercase text-white/80 group-hover:text-white transition-colors duration-300">
              Découvrir
            </span>

            {/* L'icône en dessous du texte */}
            <div className="relative mt-1">
              {/* Halo au survol */}
              <div
                className="absolute inset-0 bg-gradient-to-r from-purple-600 to-purple-800 
                           rounded-full blur opacity-0 group-hover:opacity-70 
                           transition duration-500 pointer-events-none"
              />
              <ChevronDown className="w-6 h-6 animate-bounce text-white/80 group-hover:text-white transition-colors duration-300" />
            </div>
          </button>
        </div>
      </div>

      {/* ---- Orbes animés (décor) ---- */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600/20 rounded-full filter blur-3xl animate-pulse z-0 pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-800/20 rounded-full filter blur-3xl animate-pulse delay-1000 z-0 pointer-events-none" />
    </section>
  );
}